import {
  defaultColumn,
  entitlementProperties,
} from '../../../Constants/Constant/ListingPageConstant/AdvancedSearchListingConstants'
import { adBreakPolicyProperties, languageProperties } from '../../../Constants/ManagePolicy'

export const advancedSearchConfigFunction = (path: any) => {
  const pathObjects: any = {
    '/advanced-search': {
      listingColumns: defaultColumn,
      pageKey: '/advanced-search',
    },
    '/manage-policies/entitlement': {
      listingColumns: entitlementProperties,
      pageKey: '/manage-policies/entitlement',
    },
    '/manage-policies/language': {
      listingColumns: languageProperties,
      pageKey: '/manage-policies/language',
    },
    '/manage-policies/ad-break-policy': {
      listingColumns: adBreakPolicyProperties,
      pageKey: '/manage-policies/ad-break-policy',
    },
    'bulk-state-change': {
      listingColumns: entitlementProperties,
      pageKey: 'bulk-state-change',
    },
    'interactive-bulk-update': {
      listingColumns: entitlementProperties,
      pageKey: 'interactive-bulk-update',
    },
  }
  return pathObjects[path]
}
